export default "__VITE_ASSET__D1ShYb$w__"